<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: Lato, Roboto, 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #268ef6;
  background-color: white;
/* background-image: linear-gradient(to top, #005bea 0%, #00c6fb 10%); */

}
</style>



// WEBPACK FOOTER //
// src/App.vue